import {IAppState} from '../../state/AppState';

export const getNews = (state: IAppState) =>
  state.serverApis.firestore.news.response;
